import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { TechInsightsScorecardBlueprint } from '@backstage-community/plugin-tech-insights-react/alpha';

// Tech Insights scorecards. The tech-insights frontend plugin (added in
// App.tsx) auto-discovers and provides the scorecard surface; each blueprint
// scopes its own checks + entity filter.
//
// NOTE: registering scorecard blueprints disables the plugin's default
// "all checks" scorecard. That's intentional — we render exactly the three we
// ship below.
//
// Unlike the grafana card modules, these blueprints carry config (title /
// checkIds / entityFilter), not a component render — there's no
// `(opts)=>JSX.Element` export to defer via createElement, so the established
// hooks-rules caveat doesn't apply here.

// "SLO Compliance" — self-scopes to the services carrying an slo/target
// annotation (the 5 SLO services), not every Component.
const sloScorecard = TechInsightsScorecardBlueprint.make({
  name: 'slo',
  params: {
    title: 'SLO Compliance',
    checkIds: ['sloComplianceCheck'],
    entityFilter: { 'metadata.annotations.slo/target': { $exists: true } },
  },
});

// "Documentation" — doc-completeness hygiene across all
// Components/Systems/APIs/Resources.
const docsScorecard = TechInsightsScorecardBlueprint.make({
  name: 'docs',
  params: {
    title: 'Documentation',
    checkIds: ['docHasDescription', 'docHasTechDocs', 'docHasOwner'],
    entityFilter: { kind: { $in: ['component', 'system', 'api', 'resource'] } },
  },
});

// "Plot Readiness" — self-scopes to Systems carrying heystaq.com/tenant (the
// plots), reading Heystaq's per-tenant readiness signal via tenantReadinessCheck.
// Annotation-presence (NOT bare kind:system) keeps the card off non-plot Systems.
const readinessScorecard = TechInsightsScorecardBlueprint.make({
  name: 'readiness',
  params: {
    title: 'Plot Readiness',
    checkIds: ['tenantReadinessCheck'],
    entityFilter: { 'metadata.annotations.heystaq.com/tenant': { $exists: true } },
  },
});

export const techInsightsScorecardModule = createFrontendModule({
  pluginId: 'tech-insights',
  extensions: [sloScorecard, docsScorecard, readinessScorecard],
});

export default techInsightsScorecardModule;
